// import nav from '@/nav';
import { mergeManifests } from '@/Util/manifest';


export default {
  initNav({stores}) {
  },
  initPlugins({app, stores, components}) {
  },
}
